
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class RegionApi {
    
    static activar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/region/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/region/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getRegionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/region?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getRegion(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/region/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(region, token ) {          
      let regionEnvio = Object.assign({}, region);
		let comando="POST";
		if (regionEnvio.id > 0) {
			comando="PUT";			
		} 
		regionEnvio=JSON.stringify(regionEnvio);
		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/region/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: regionEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getRegionCombo(token ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/region/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
     static getRegionComboByPais(token, paisId ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/region/comboByPais/"+paisId,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
     

    
}